module.exports = __webpack_public_path__ + "static/illustration-lg-6bd889504d64bc018938ec817e8674ce.png";